import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserRegistrationEmailService {
  constructor(protected readonly httpClient: HttpClient) {}

  public sendUserConfirmationRequestEmail(
    email: string,
    propositionId?: number,
    interfaceTypeId?: number
  ): Observable<any> {
    return this.httpClient.post('/Emails/sendUserRegistrationConfirmationEmail', {
      email,
      propositionId,
      interfaceTypeId
    });
  }

  public resendUserConfirmationRequestEmail(
    email: string,
    propositionId?: number,
    interfaceTypeId?: number
  ): Observable<any> {
    return this.httpClient.post('/Emails/resendUserConfirmationRequestEmail', {
      email,
      propositionId,
      interfaceTypeId
    });
  }
}
